import {
  IntroducingBrokerMerkActivitiesParams,
  MerkActivity,
} from "@letsbit/malcolmlb";
import {
  SWRInfiniteResponseCustom,
  useAuthInfiniteSWR,
} from "hooks/utils/useAuthSWR";
import { ApiContext } from "providers/ApiProvider";
import { UserContext } from "providers/UserProvider";
import { useContext } from "react";

export const SWR_INTRODUCING_MEMBER_MEMBER_MERK_HISTORY_KEY =
  "get-introducing-broker-member-merk-history";

export const useIntroducingBrokerMemberMerkActivities = (
  params: IntroducingBrokerMerkActivitiesParams,
): SWRInfiniteResponseCustom<MerkActivity[]> => {
  const { memberInstance } = useContext(ApiContext);
  const { user } = useContext(UserContext);
  const uuid = user?.uid;
  const swrKey = [SWR_INTRODUCING_MEMBER_MEMBER_MERK_HISTORY_KEY, params];
  const swr = useAuthInfiniteSWR(
    swrKey,
    async (withPage): Promise<MerkActivity[]> => {
      const { data } = await memberInstance.partner.getMemberHistoryMarket(
        withPage[0][1],
      );
      return data;
    },
    undefined,
    (_, previousPageData) => {
      const pageToken = previousPageData?.[previousPageData.length - 1]?.id;
      return [
        [
          SWR_INTRODUCING_MEMBER_MEMBER_MERK_HISTORY_KEY,
          { ...params, page_token: pageToken },
          uuid,
        ],
        { page_token: pageToken },
      ];
    },
  );

  return swr;
};
